<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">개인정보설정</span>
            <span class="txt">직원 본인의 기본정보를 설정하고 근무시간을 확인합니다.</span>
        </div>

        <div class="employee-top-info">
            <ul class="select-photo-list">
                <li>
                    <a href="#">
                        <img
                            :src="employeeInfo.imageUrl === null ? '/img/temp/no_photo.jpg' : employeeInfo.imageUrl"
                            alt=""
                            @error="imageUrlAlt"
                        />
                        <span class="name">{{ staffTopInfo.name }}</span>
                        <span class="tel">{{ staffTopInfo.phone | phoneNumberFilter }}</span>
                        <span class="type">{{ staffTopInfo.roleName }}</span>
                        <span class="detail">{{ staffTopInfo.staffTeams }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="com-tab">
            <button class="on">기본정보</button>
            <button @click="onClickRouter('/madmin/mypage/time')">근무시간</button>
        </div>

        <div class="com-card-input half-type">
            <div class="left-box">
                <div class="line">
                    <span class="tit">사진</span>
                    <div class="input-cnt photo-line">
                        <span class="photo">
                            <img :src="defaultImageUrl" alt="사진" @error="imageUrlAlt" />
                        </span>
                        <div class="info-txt">
                            <span class="txt">※ 권장 이미지 : 정사각형 사이즈, JPG, PNG 가능</span>
                            <b-form-file id="file1" accept=".jpg, .png, .gif" plain @change="handleImage"></b-form-file>
                            <label class="com-btn" for="file1">사진등록</label>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <div class="division">
                        <span class="tit">
                            이름
                            <span class="imp">*</span>
                        </span>
                        <div class="input-cnt">
                            <input v-model="editField.name" class="w220" type="text" />
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        연락처
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-tel select-type">
                            <input
                                v-model="editField.phone[0]"
                                maxlength="3"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onChangePhoneNumber"
                            />
                            <input
                                v-model="editField.phone[1]"
                                maxlength="4"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onChangePhoneNumber"
                            />
                            <input
                                v-model="editField.phone[2]"
                                maxlength="4"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onChangePhoneNumber"
                            />

                            <button class="com-btn" @click="checkDuplicatePhone">중복확인</button>
                            <span id="isCheckedPhoneMsg" class="error red" v-html="isCheckedPhoneMsg"></span>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        직급/권한
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <select-form
                            :select-data="['선택', ...roleTypeList]"
                            :select-value="['', ...roleTypeValueList]"
                            :selected-value="editField.roleId"
                            class="w220"
                            disabled
                            @update:set="(val) => (editField.roleId = val)"
                        ></select-form>
                    </div>
                    <span class="sub-info">※ 상세권한 수정은 직원설정 > 권한설정에서 가능합니다.</span>
                </div>
                <div class="line">
                    <span class="tit">팀</span>
                    <div class="input-cnt flex-wrap">
                        <select-form
                            :select-data="['선택', ...teamList]"
                            :select-value="['', ...teamValueList]"
                            :selected-value="team"
                            class="w400"
                            disabled
                        ></select-form>
                        <button class="com-btn" @click="onClickAddTeam">추가</button>
                        <!-- 추가 일시 -->
                        <!-- <div class="sub-line">
                <input type="text" class="w400">
                <button class="com-btn red">삭제</button>
            </div>
            <div class="sub-line">
                <input type="text" class="w400">
                <button class="com-btn red">삭제</button>
            </div> -->
                        <!-- //추가 일시 -->
                    </div>
                </div>
                <div class="line">
                    <span class="tit">자격증 및 경력사항</span>
                    <div class="input-cnt">
                        <textarea v-model="editField.memo" class="com-textarea w400"></textarea>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="line">
                    <span class="tit">센터명</span>
                    <div class="input-cnt">
                        <select-form
                            :select-data="[centerName]"
                            :select-value="[centerName]"
                            :selected-value="centerName"
                            class="w220"
                            disabled
                        ></select-form>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        이메일
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-email">
                            <input v-model="editField.email[0]" class="first" disabled type="text" />
                            <span class="txt">@</span>
                            <input v-model="editField.email[1]" class="last" disabled type="text" />
                            <!-- <select-form :select-data='["선택"]'></select-form> 추후 추가-->
                        </div>
                    </div>
                </div>
                <!--
        고객 요구에 의해서 해당 입력폼 삭제
        <div class="line">
            <span class="tit">비밀번호 <span class="imp">*</span></span>
            <div class="input-cnt">
                <input type="password" class="w220" v-model="editField.password" />
            </div>
        </div>
        -->
                <!--
        고객 요구에 의해서 해당 입력폼 삭제
        <div class="line">
            <span class="tit">비밀번호 확인 <span class="imp">*</span></span>
            <div class="input-cnt">
                <input type="password" class="w220" v-model="editField.rePassword" />
            </div>
        </div>
        -->
                <div class="line">
                    <span class="tit">생년월일</span>
                    <div class="input-cnt">
                        <!-- <single-calendar class="w220" :date="birthday"></single-calendar> -->
                        <single-calendar
                            :date="editField.birthday"
                            class="w220"
                            @update="onChangeBirthDay1"
                        ></single-calendar>
                        <input
                            :value="editField.birthday"
                            maxlength="8"
                            placeholder="생년월일 직접 입력"
                            type="text"
                            @change="onChangeBirthDay2"
                            @keypress="isNumber($event)"
                        />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">컬러</span>
                    <div class="input-cnt">
                        <div class="color-code">
                            <button
                                :style="{ backgroundColor: colorCodeData }"
                                class="pop-btn"
                                @click="colorPop = !colorPop"
                            ></button>
                            <!-- 클릭시 연동되는 배경칼라// -->
                            <div v-show="colorPop" class="color-select">
                                <div v-for="c in colorCodeArray" :key="c">
                                    <button
                                        :class="{ on: colorCodeData == c }"
                                        :disabled="teachersColor.includes(c) && editField.color !== c"
                                        :style="colorButtonIsDisabled(c, editField.color)"
                                        @click="
                                            colorCodeData = c;
                                            colorPop = false;
                                        "
                                    >
                                        {{ c }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        스케줄표 노출여부
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input
                                id="radio-s1-1"
                                v-model="editField.scheduleShowYn"
                                name="radio-s1"
                                type="radio"
                                value="true"
                            />
                            <label for="radio-s1-1">노출</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-s1-2"
                                v-model="editField.scheduleShowYn"
                                name="radio-s1"
                                type="radio"
                                value="false"
                            />
                            <label for="radio-s1-2">미노출</label>
                        </div>
                        <span class="sub-info">※ 일일스케줄/그룹주간표/강사주간표/룸스케줄에 노출합니다.</span>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        회원예약 노출여부
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input
                                id="radio-s2-1"
                                v-model="editField.reserveShowYn"
                                name="radio-s2"
                                type="radio"
                                value="true"
                            />
                            <label for="radio-s2-1">노출</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-s2-2"
                                v-model="editField.reserveShowYn"
                                name="radio-s2"
                                type="radio"
                                value="false"
                            />
                            <label for="radio-s2-2">미노출</label>
                        </div>
                    </div>
                    <span class="sub-info">※ 회원예약 어플리케이션에 노출합니다.</span>
                </div>
                <div class="line">
                    <span class="tit">정보 노출여부</span>
                    <div class="input-cnt">
                        <div class="com-check">
                            <input id="check-c1-1" v-model="editField.phoneShowYn" name="check-c1" type="checkbox" />
                            <label for="check-c1-1">휴대전화</label>
                        </div>
                        <div class="com-check">
                            <input id="check-c1-2" v-model="editField.emailShowYn" name="check-c1" type="checkbox" />
                            <label for="check-c1-2">이메일</label>
                        </div>
                        <div class="com-check">
                            <input id="check-c1-3" v-model="editField.certShowYn" name="check-c1" type="checkbox" />
                            <label for="check-c1-3">자격증 및 경력사항</label>
                        </div>
                    </div>
                    <span class="sub-info">※ 체크 시, 회원예약 어플리케이션 '강사정보보기'에 노출됩니다.</span>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <!--
      고객 요구에 의해서 버튼 삭제
      <button class="com-btn">취소</button>
      -->
            <button class="com-btn blue" @click="saveMyPage">저장</button>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';

export default {
    name: 'MypageInfo',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        fullPhoneNumber() {
            const ed = this.editField;
            return `${ed.phone[0]}${ed.phone[1]}${ed.phone[2]}`;
        },
        fullEmail() {
            const ed = this.editField;
            return `${ed.email[0]}@${ed.email[1]}`;
        },
    },
    data() {
        return {
            colorPop: false,
            colorCodeData: '', // 기본 설정 칼라
            centerId: '',
            centerStaffId: this.$store.state.auth.user.uid,
            isCheckedPhone: false, // 연락처 중복확인 여부
            isCheckedPhoneMsg: '', // 연락처 중복확인 메세지
            availablePhoneNumber: '', // 중복확인한 번호
            positionList: ['대표', '강사', '매니저', '상담원', '기타직원'],
            positionValueList: ['P', 'T', 'M', 'C', 'N'],
            position: '', // 직급
            phone: '', // 중복번호 확인을 위한 phone 객체
            duplicate: '', // 핸드폰 번호 중복 값 확인
            // password:'', //비밀번호
            memo: '',
            team: '',
            teamList: [],
            teamValueList: [],
            centerName: '',
            centerNameList: [],

            employeeInfo: {},
            staffTopInfo: {
                // 상단에 노출되는 직원 정보 UI
                name: '',
                phone: '',
                roleName: '',
                staffTeams: '',
            },
            editField: {
                roleId: '',
                name: '',
                nickName: '',
                // password: '',
                // rePassword: '',
                memo: '',
                phone: ['', '', ''],
                email: ['', ''],
                birthday: '',
                sex: '', // 남성 : M, 여성 : W
                color: '',
                status: '', // 입사 : I, 퇴사 : O
                classType: '', // 대표 : P, 강사 : T, 매니저 : M, 상담원 : C, 기타직원 : N
                scheduleShowYn: true, // 스케줄표노출여부
                reserveShowYn: true, // 회원예약노출여부
                phoneShowYn: false, // 정보노출휴대전화
                emailShowYn: false, // 정보노출이메일
                certShowYn: false, // 정보노출자격증
                imageFile: {
                    filename: '',
                    mimetype: '',
                    base64data: '',
                },
                staffTeams: [],
                staffAuthNumber: '',
            },
            roleTypeList: [], // roleName List
            roleTypeValueList: [], // roleId List
            defaultImageUrl: '/img/temp/no_photo.jpg',

            teachersColor: [], // 선생들컬러
            colorCodeArray: [
                '#f44336',
                '#e91e63',
                '#9c27b0',
                '#673ab7',
                '#3f51b5',
                '#2196f3',
                '#03a9f4',
                '#00bcd4',
                '#009688',
                '#4caf50',
                '#8bc34a',
                '#cddc39',
                '#ffeb3b',
                '#ffc107',
                '#ff9800',
                '#ff5722',
                '#f472b6',
                '#8b5cf6',
                '#0099cc',
                '#1e40af',
                '#dc2626',
                '#854d0e',
                '#064e3b',
                '#3f6212',
                '#fca5a5',
                '#f87171',
                '#e94265',
                '#f6a66f',
                '#a7f3d0',
                '#2dd4bf',
                '#d9f99d',
                '#4ade80',
            ], // 컬러 코드 배열
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.onSearchList();
        this.fetchCenterStaffRole();
        this.invalidColorForTeacher();
    },
    methods: {
        // 센터 직급/권한 목록 가져오기
        async fetchCenterStaffRole() {
            try {
                let { centerStaffRoleList, roleTypeList, roleTypeValueList } = this;

                const { data } = await this.sendGetCenterStaffRole();

                centerStaffRoleList = data;
                centerStaffRoleList.forEach((role) => {
                    roleTypeList.push(role.roleName);
                    roleTypeValueList.push(String(role.roleId));
                });
                console.log('===> Loading Center Staff Role List Successfully : ', data);
            } catch (error) {
                alert('직급/권한을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 직급권한 목록 조회 API
        sendGetCenterStaffRole() {
            return api.get(`/admin/api/centerStaffRole/${this.centerId}/all`);
        },

        // 담당 직원 API 호출
        async onSearchList() {
            try {
                this.isLoading = true;
                const centerNameData = await this.getCenterNameData();
                this.centerName = centerNameData.data.centerName;
                this.centerNameList.push(this.centerName);
                const { data } = await this.getCenterList();

                console.log(data);
                this.staff = data; // 오브젝트 하나.
                data.centerStaffTeams.forEach((g) => {
                    this.teamList.push(g.centerTeam.name); // 값 수정필요
                    this.teamValueList.push(g.centerTeamId); // 값 수정 필요
                });

                this.employeeInfo = { ...data };

                const { editField, employeeInfo, staffTopInfo } = this;
                this.defaultImageUrl =
                    this.employeeInfo.imageUrl == null ? '/img/temp/no_photo.jpg' : this.employeeInfo.imageUrl; // 사진

                staffTopInfo.name = employeeInfo.name;
                staffTopInfo.phone = employeeInfo.phone;

                if (employeeInfo.centerStaffRole) {
                    staffTopInfo.roleName = employeeInfo.centerStaffRole.roleName;
                } else {
                    staffTopInfo.roleName = '-';
                }

                if (employeeInfo.centerStaffTeams.length == 1) {
                    staffTopInfo.staffTeams = employeeInfo.centerStaffTeams[0].centerTeam.name;
                } else if (employeeInfo.centerStaffTeams.length == 0) {
                    staffTopInfo.staffTeams = '-';
                } else {
                    staffTopInfo.staffTeams = `${employeeInfo.centerStaffTeams[0].centerTeam.name} 외 ${
                        employeeInfo.centerStaffTeams.length - 1
                    }`;
                }

                console.log(employeeInfo);

                editField.roleId = String(employeeInfo.roleId);
                editField.name = employeeInfo.name;
                editField.memo = employeeInfo.memo;
                editField.birthday = employeeInfo.birthday;
                editField.color = employeeInfo.color;
                this.colorCodeData = employeeInfo.color;
                editField.scheduleShowYn = employeeInfo.scheduleShowYn;
                editField.reserveShowYn = employeeInfo.reserveShowYn;
                editField.phoneShowYn = employeeInfo.phoneShowYn;
                editField.emailShowYn = employeeInfo.emailShowYn;
                editField.certShowYn = employeeInfo.certShowYn;
                editField.classType = employeeInfo.classType;
                editField.birthday = this.splitBirthday(employeeInfo.birthday);
                editField.phone = this.splitPhoneNumber(employeeInfo.phone);
                editField.email = this.splitEmail(employeeInfo.email);
                editField.staffAuthNumber = employeeInfo.staffAuthNumber;
                if (this.employeeInfo.centerStaffTeams > 1) {
                    this.team = this.employeeInfo.centerStaffTeams[0].centerTeam.centerTeamId; // 선택된 팀 값
                }
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 담당 직원 조회 API
        getCenterList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}`);
        },

        // 핸드폰 번호 나눠서 배열로 저장
        phoneSplit(phone) {
            var phone = phone;
            var phone = phone.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
            const phone2 = phone.split('-');
            this.phone2 = phone2;
            console.log('핸드폰 번호 배열', phone2);
        },
        // 이메일 불러오기
        getEmail(email) {
            console.log('넘어오고있는 이메일값', email);
            var email = email;
            var email = email.split('@');
            this.email = email; // 이메일 배열로 뿌려주기
        },
        // 생일 지정
        getBirthday(birthday) {
            const formatbirthday = birthday.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'); // 하이픈 추가
            this.birthday = formatbirthday; // 변환
        },
        // Image 핸들러
        handleImage(e) {
            const selectedImage = e.target.files[0];
            this.editField.imageFile.filename = selectedImage.name;
            this.editField.imageFile.mimetype = selectedImage.type;
            this.createBase64Image(selectedImage);
        },
        // staff image 없을 경우 default image 표시
        imageUrlAlt(event) {
            event.target.src = '/img/temp/no_photo.jpg';
        },
        // 중복 번호 확인
        async getDuplicateNumber() {
            try {
                this.phone = this.phone2.join('');
                console.log('합쳐진 값', this.phone);
                const { data } = await this.checkPhoneNumber();
                console.log('중복번호 확인 데이터', data);
                if (data.phoneNumberCount != 0) {
                    console.log('데이터존재');
                    this.duplicate = true;
                } else {
                    console.log('데이터 미존재');
                    this.duplicate = false;
                }
            } catch (error) {
                console.log('에러입니다.');
            }
        },
        // 휴대폰 중복번호 확인
        checkPhoneNumber() {
            console.log('넘어오는값', this.phone);
            return api.get(`/admin/api/center/${this.centerId}/staff/phoneNumberDeplexCheck/${this.phone}`);
        },
        async reqSaveMyPage() {
            try {
                const params = this.getUpdateParams();
                const { data } = await this.sendPutStaff(params);
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        // 마이페이지 내용 저장
        saveMyPage() {
            const params = this.getUpdateParams();
            api.put(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}`, {
                ...params,
            })
                .then(() => {
                    alert('수정이 완료되었습니다.');
                })
                .catch((error) => {
                    alert('오류가 발생했습니다.');
                    console.error(error);
                });
        },

        getUpdateParams() {
            const {
                name,
                nickName,
                // password,
                // rePassword,
                scheduleShowYn,
                reserveShowYn,
                phoneShowYn,
                emailShowYn,
                certShowYn,
                imageFile,
                memo,
                staffTeams,
                roleId,
            } = this.editField;
            const phone = this.fullPhoneNumber;
            const email = this.fullEmail;
            const color = this.colorCodeData;
            const birthday = this.editField.birthday.replace(/-/g, '');
            // 현재 UI에 입력값 없음
            const sex = 'M';
            const classType = 'T'; // 대표 = "P", 강사 = "T", 매니저 = "M", 상담원 = "C", 기타직원 = "N"   확인 후 수정 예정

            const params = {
                roleId,
                name,
                nickName,
                birthday,
                sex,
                phone,
                classType,
                email,
                // password,
                // rePassword,
                color,
                scheduleShowYn,
                reserveShowYn,
                phoneShowYn,
                emailShowYn,
                certShowYn,
                imageFile,
                memo,
                staffTeams,
            };
            if (imageFile.filename === '') {
                // 사진을 수정하지 않았으면 imageFile은 삭제
                delete params.imageFile;
            }
            return params;
        },

        // Base64 Image 생성
        createBase64Image(fileObj) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.defaultImageUrl = e.target.result;
                this.editField.imageFile.base64data = this.defaultImageUrl.split(',')[1];
            };
            reader.readAsDataURL(fileObj);
        },

        // 자동으로 하이픈을 추가해주는 함수
        addDashes() {
            let number = this.birthday;
            number = number
                .replace(/[^0-9]/g, '')
                .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{2})$/, '$1-$2-$3')
                .replace('--', '-');
            this.birthday = number;
            console.log(this.birthday);
        },
        // 숫자외 문자 입력금지 함수
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        // 연락처 변경 이벤트
        onChangePhoneNumber() {
            const { fullPhoneNumber } = this;

            switch (fullPhoneNumber) {
                case '':
                case this.employeeInfo.phone:
                case this.availablePhoneNumber:
                    this.isCheckedPhone = true;
                    break;
                default:
                    this.isCheckedPhone = false;
                    break;
            }
        },
        // 생년월일 format '-'으로 변경
        splitBirthday(birthday) {
            if (birthday.length === 8) {
                return birthday.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
            }
        },
        // 연락처 split
        splitPhoneNumber(phoneNumber) {
            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length == 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },
        // 이메일 주소 Split
        splitEmail(email) {
            if (!email) return email;

            const tmp = ['', ''];
            tmp[0] = email.split('@')[0];
            tmp[1] = email.split('@')[1];
            return tmp;
        },
        onClickAddTeam() {
            if (this.curSelectedTeam === '') {
                alert('팀을 선택하세요.');
                return;
            }

            // 이미 추가되어 있는 팀인지 찾기
            let duplicateTeam = false;
            this.editField.staffTeams.forEach((team) => {
                if (String(team.centerTeamId) === String(this.curSelectedTeam)) {
                    duplicateTeam = true;
                }
            });
            if (duplicateTeam) {
                // true이면 이미 추가되어 있는 팀
                alert('이미 추가된 팀입니다.');
                this.curSelectedTeam = '';
                return;
            }

            const { teamTypeList, editField } = this;
            const index = this.teamTypeValueList.findIndex((value) => value === this.curSelectedTeam);
            const teamName = teamTypeList[index];

            const tempObj = {
                centerTeamId: this.curSelectedTeam,
                centerTeamName: teamName,
            };
            editField.staffTeams.push(tempObj);

            this.curSelectedTeam = '';
        },
        // 연락처 중복확인
        async checkDuplicatePhone() {
            // 이미 체크한 경우
            if (this.isCheckedPhone) {
                return;
            }

            const {
                phone: [phoneFirst, phoneSecond, phoneThird],
            } = this.editField;

            // 전화번호
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                alert('연락처를 입력하세요.');
                return false;
            }

            this.isProgressPhoneCheck = true;
            const { data } = await api.get(
                `/admin/api/center/${this.centerId}/staff/phoneNumberDeplexCheck/${this.fullPhoneNumber}`
            );

            const msg = document.querySelector('#isCheckedPhoneMsg');

            if (data.phoneNumberCount === 0) {
                this.isCheckedPhone = true;
                this.isCheckedPhoneMsg = '사용 가능합니다.';
                this.availablePhoneNumber = this.fullPhoneNumber;
                msg.className = 'error green';
            } else {
                this.isCheckedPhone = false;
                this.isCheckedPhoneMsg = '사용중인 번호입니다.';
                this.availablePhoneNumber = '';
                msg.className = 'error red';
            }
            this.isProgressPhoneCheck = false;
        },

        onChangeBirthDay1(date) {
            this.editField.birthday = date;
        },

        onChangeBirthDay2(e) {
            const dateString = e.target.value;
            const length = dateString.length;
            console.log(length - 2);
            const day = dateString.slice(length - 2, length);
            const month = dateString.slice(length - 4, length - 2);
            const year = dateString.slice(0, length - 4);

            if (Number(day) < 1) {
                alert('날짜에 음수를 넣을 수가 없습니다.');
                this.editField.birthday = '';
                return;
            }

            const lastDay = this.getLastDayByMonth(month, year);

            if (lastDay === 0) {
                alert('날짜를 잘못 입력하였습니다.');
                this.editField.birthday = '';
                return;
            }

            if (Number(day) > lastDay && month !== '02') {
                alert(`${Number(month)}월은 ${lastDay}일 밖에 없습니다.`);
                this.editField.birthday = '';
                return;
            } else if (Number(day) > lastDay && month === '02') {
                alert(`${year}년 ${Number(month)}월은 ${lastDay}일 밖에 없습니다.`);
                this.editField.birthday = '';
                return;
            }

            this.editField.birthday = new Date(Number(year), Number(month) - 1, Number(day));
        },

        // 날짜와 달이 주어지면 해당 달이 몇일까지 있는지 반환하는 함수
        getLastDayByMonth(month, year) {
            if (
                month === '01' ||
                month === '03' ||
                month === '05' ||
                month === '07' ||
                month === '08' ||
                month === '10' ||
                month === '12'
            ) {
                return 31;
            } else if (month === '04' || month === '06' || month === '09' || month === '11') {
                return 30;
            } else if (month === '02') {
                if (Number(year) % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
                    return 29;
                }
                return 28;
            }

            return 0;
        },

        // 센터명을 조회할 수 있는 데이터를 가져오는 함수
        getCenterNameData() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        async invalidColorForTeacher() {
            try {
                const colors = await this.getTeachersInfo();
                for (const color of colors) {
                    if (this.colorCodeData === color) {
                        this.editField.color = this.colorCodeData;
                    } else {
                        this.teachersColor.push(color.color);
                    }
                }
            } catch (error) {
                console.log('noColor..');
            }
        },
        getTeachersInfo() {
            return api
                .get(`/admin/api/center/${this.cId}/staff/teachers/list`)
                .then((response) => response.data)
                .catch((error) => {});
        },
        colorButtonTrueOrFalse(colorCode) {
            let answer = false;
            answer = this.teachersColor.includes(colorCode);
            return answer;
        },
        colorButtonIsDisabled(colorCode, filledColor) {
            const answer = {};
            if (this.colorButtonTrueOrFalse(colorCode)) {
                answer.backgroundColor = colorCode;

                if (filledColor !== colorCode) {
                    answer.opacity = '0.8';
                    answer.background = `repeating-linear-gradient(135deg, ${colorCode}, ${colorCode} 5px, #ffffff 5px, #ffffff 7px)`;
                } else {
                    answer.background = `${colorCode}`;
                }
            } else {
                answer.backgroundColor = colorCode;
            }
            return answer;
        },
    },
};
</script>
<style lang="scss"></style>
